import React from "react";

import "./detailAside.css";
import { Link } from "react-router-dom";

const DetailAside = ({
  course_img,
  title,
  price_old,
  price_new,
  price_discount,
  features,
}) => {
  return (
    <aside className="course-aside box p-3">
      <div className="aside-header">
        <div className="header-img">
          <img src={course_img} alt={title} className="rounded-3" />
        </div>
        <div className="header-info">
          <div className="info-icon mb-2 ms-4">
            <i className="fas fa-play"></i>
          </div>
          <div className="info-text fs-6">{/* <span>Play now</span> */}</div>
        </div>
      </div>

      <div className="aside-features my-3">
        <h5 className="mb-2">Ilmiy tadqiqotlar</h5>
        <ul>
          {features.map((item, index) => (
            <li key={index} className="d-flex mb-2">
              <div className="feature-icon theme-clr">
                <i className={item.icon}></i>
              </div>
              <div className="feature-text ms-2">{item.title}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className="aside-btn">
        <Link to="/contact">
          <button type="button" className="theme-btn w-100">
            Ro‘yxatdan o‘tish
          </button>
        </Link>
      </div>
    </aside>
  );
};

export default DetailAside;
